"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromVector = exports.fromPotential = exports.fromMotivation = exports.fromLifeBase = void 0;
const article_1 = __importDefault(require("./article"));
const list_1 = require("./list");
/**
 * Create the Markdown from the LifeBase resources.
 * @param resource The resource of tne LifeBase.
 * @param source The source.
 */
const fromLifeBase = ({ getByKey, getCategoryDetail, }, source) => {
    const { detail, name } = getByKey(source);
    return list_1.line(article_1.default({ body: name, head: getCategoryDetail(), level: 2 }), list_1.list(...detail));
};
exports.fromLifeBase = fromLifeBase;
/**
 * Create the Markdown from the Motivation resources.
 * @param resource The resource of tne motivation.
 * @param source The source.
 */
const fromMotivation = ({ getByKey, getCategoryDetail }, source) => article_1.default({ body: getByKey(source), head: getCategoryDetail(), level: 2 });
exports.fromMotivation = fromMotivation;
/**
 * Create the Markdown from the Potential resources.
 * @param accessor The accessor of the Potential.
 * @param source The source.
 */
const fromPotential = (accessor, source) => {
    const desc = accessor.getCategoryDetail();
    return list_1.line(article_1.default({ body: desc.detail, head: desc.name, level: 2 }), list_1.list(...accessor.getByKey(source)));
};
exports.fromPotential = fromPotential;
/**
 * Create the Markdown from the vector resources.
 * @param description The resource of tne description.
 * @param source The source.
 */
const fromVector = (description, source) => list_1.line(article_1.default({ head: source.name, body: list_1.list(...source.detail), level: 3 }), article_1.default({ head: description, body: list_1.list(...source.strategy), level: 4 }));
exports.fromVector = fromVector;
//# sourceMappingURL=specialized.js.map